import React, { useRef } from "react";

const svgPath_pb7c7e00 =
  "M1.58946e-07 5.33333C1.58946e-07 8.27885 2.38781 10.6667 5.33333 10.6667C8.27885 10.6667 10.6667 8.27885 10.6667 5.33333C10.6667 2.38781 8.27885 1.58946e-07 5.33333 1.58946e-07C2.38781 1.58946e-07 1.58946e-07 2.38781 1.58946e-07 5.33333ZM32 5.33333C32 8.27885 34.3878 10.6667 37.3333 10.6667C40.2789 10.6667 42.6667 8.27885 42.6667 5.33333C42.6667 2.38781 40.2789 1.58946e-07 37.3333 1.58946e-07C34.3878 1.58946e-07 32 2.38781 32 5.33333ZM5.33333 5.33333V6.33333H37.3333V5.33333V4.33333H5.33333V5.33333Z";

function Frame50() {
  return (
    <div className="content-stretch flex flex-col gap-[8px] items-start justify-center relative shrink-0">
      <p
        className="font-['Roboto:Medium',sans-serif] font-medium leading-tight md:leading-[48px] relative shrink-0 text-3xl sm:text-4xl md:text-[48px] text-black text-center w-full"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        How It Works
      </p>
    </div>
  );
}

function Frame59() {
  return (
    <div className="content-stretch flex gap-[16px] items-center justify-center relative shrink-0 w-full">
      <Frame50 />
    </div>
  );
}

function Frame8() {
  return (
    <div className="content-stretch flex flex-col gap-[32px] items-center relative shrink-0 w-full">
      <Frame59 />
    </div>
  );
}

function Frame62() {
  return (
    <div className="content-stretch flex flex-col gap-[72px] h-auto md:h-[34px] items-start relative shrink-0 w-full px-4 md:px-0">
      <Frame8 />
    </div>
  );
}

// ✅ Your step images — now the only ones used
const steps = [
  {
    number: "1",
    title: "Post Your Requirement",
    description:
      "Share what you need, whether it's a project or a personal service.",
    image: "/images/work/post yr requirmnt.png",
  },
  {
    number: "2",
    title: "Find the Right Freelancer",
    description:
      "Browse profiles, portfolios, and ratings to find the ideal fit.",
    image: "/images/work/find freelancer.png",
  },
  {
    number: "3",
    title: "Connect Directly",
    description:
      "Chat with freelancers, discuss your terms, and agree on deliverables.",
    image: "/images/work/connect dirctly.png",
  },
  {
    number: "4",
    title: "Get It Done",
    description: "Collaborate efficiently and achieve great results together.",
    image: "/images/work/assigned.png",
  },
];

function StepCard({ step }) {
  return (
    <div className="content-stretch flex flex-col gap-3 sm:gap-4 md:gap-5 lg:gap-[32px] items-start relative shrink-0 w-[160px] sm:w-[200px] md:w-[240px] lg:basis-0 lg:grow lg:min-w-0">
      {/* ✅ Step Image (no dummy) */}
      <div className="h-[120px] sm:h-[150px] md:h-[180px] lg:h-[206px] relative rounded-xl md:rounded-2xl lg:rounded-[16px] shadow-[0px_4px_20px_0px_rgba(58,89,156,0.15)] shrink-0 w-full overflow-hidden">
        <img
          src={step.image}
          alt={step.title}
          className="object-cover w-full h-full rounded-xl md:rounded-2xl lg:rounded-[16px]"
        />
        <div className="absolute bg-[rgba(0,0,0,0.12)] inset-0 rounded-xl md:rounded-2xl lg:rounded-[16px]" />
      </div>

      {/* Step Content */}
      <div className="box-border content-stretch flex flex-col items-center pt-0 px-0 relative shrink-0 w-full min-h-[110px] sm:min-h-[120px] md:min-h-[130px]">
        <p
          className="font-['Roboto:Medium',sans-serif] font-medium leading-[50px] sm:leading-[70px] md:leading-[95px] lg:leading-[100px] xl:leading-[120px] 2xl:leading-[136.663px] relative text-[#e6e6e6] text-[50px] sm:text-[70px] md:text-[95px] lg:text-[100px] xl:text-[120px] 2xl:text-[136.663px] text-right w-full -mb-[25px] sm:-mb-[35px] md:-mb-[48px] lg:-mb-[50px] xl:-mb-[58px] 2xl:-mb-[63px]"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          {step.number}
        </p>
        <div className="box-border content-stretch flex flex-col gap-1 sm:gap-1.5 md:gap-2.5 lg:gap-3 xl:gap-[14px] 2xl:gap-[16px] items-center leading-[16px] sm:leading-[18px] md:leading-5 lg:leading-[20px] xl:leading-[22px] 2xl:leading-[24px] relative shrink-0 text-[11px] sm:text-xs md:text-sm lg:text-[13px] xl:text-[14.5px] 2xl:text-[16px] text-black text-center w-full px-1.5 sm:px-2 lg:px-1 xl:px-0 z-10">
          <p
            className="font-['Roboto:SemiBold',sans-serif] font-semibold relative shrink-0 w-full"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            {step.title}
          </p>
          <p
            className="font-['Roboto:Regular',sans-serif] font-normal relative shrink-0 w-full"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            {step.description}
          </p>
        </div>
      </div>
    </div>
  );
}

function Frame44() {
  return (
    <div className="relative shrink-0 w-[16px] sm:w-[20px] md:w-[26px] lg:w-[32px] self-start mt-[60px] sm:mt-[75px] md:mt-[90px] lg:mt-[103px]">
      <div className="h-[78px] sm:h-[98px] md:h-[118px] lg:h-[137px]">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 43 143"
        >
          <path
            d={svgPath_pb7c7e00}
            fill="var(--stroke-0, #888888)"
            fillOpacity="0.54"
          />
        </svg>
      </div>
    </div>
  );
}

function FrameHowItWorksRow() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="relative w-full">
      {/* Scroll Buttons (Mobile only) */}
      <button
        onClick={() => scroll("left")}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-2 sm:p-2.5 md:p-2.5 lg:p-3 hover:bg-gray-100 transition-colors lg:hidden"
        aria-label="Scroll left"
      >
        <svg
          className="w-5 h-5 sm:w-5 md:w-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      {/* Scrollable Steps */}
      <div
        ref={scrollRef}
        className="flex flex-row gap-3 sm:gap-4 md:gap-5 lg:gap-[32px] items-start overflow-x-auto lg:overflow-x-visible scrollbar-hide scroll-smooth px-6 sm:px-8 md:px-10 lg:px-0 lg:basis-0 lg:grow lg:min-w-0"
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <StepCard step={step} />
            {index < steps.length - 1 && <Frame44 />}
          </React.Fragment>
        ))}
      </div>

      <button
        onClick={() => scroll("right")}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-2 sm:p-2.5 md:p-2.5 lg:p-3 hover:bg-gray-100 transition-colors lg:hidden"
        aria-label="Scroll right"
      >
        <svg
          className="w-5 h-5 sm:w-5 md:w-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      {/* Hide Scrollbar */}
      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}

function Frame48() {
  return (
    <div className="relative shrink-0 w-full">
      <div className="flex flex-row items-center justify-center w-full">
        <div className="box-border content-center flex items-center justify-center px-0 lg:px-8 xl:px-12 2xl:px-[144px] py-0 relative w-full">
          <FrameHowItWorksRow />
        </div>
      </div>
    </div>
  );
}

export default function HowItWorksSection() {
  return (
    <div className="box-border content-stretch flex flex-col gap-[48px] items-start px-0 py-[48px] relative shrink-0 w-full">
      <Frame62 />
      <Frame48 />
    </div>
  );
}
